import { Box } from '@mui/material';
import { observerElement } from 'components/StoreLayout/useObserver';
import { useEffect, useRef } from 'react';
import { useStoreState } from 'state/hooks/store.state.hook';
import { OfferData } from 'utils/types';

const CarouselItem = ({
  children,
  data,
}: {
  children: React.ReactNode;
  data: OfferData;
}) => {
  const { sendEvent } = useStoreState();

  const itemRef = useRef<HTMLDivElement>(null);

  useEffect(() => {
    if (!itemRef?.current || !sendEvent) return;
    observerElement(itemRef.current, data, sendEvent);
  }, [itemRef?.current, sendEvent]);

  return (
    <Box className="carousel-item" ref={itemRef}>
      {children}
    </Box>
  );
};

export default CarouselItem;
